import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импорт JSON-файлов переводов
import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
  en: { translation: translationEN },
  ru: { translation: translationRU },
};

i18n
  .use(LanguageDetector) // Подключаем автоопределение языка
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Язык по умолчанию, если что-то пошло не так
    supportedLngs: ['en', 'ru'],
    
    // Настройка детектора языка
    detection: {
      // Сначала проверяем localStorage. Если там нет — ничего не делаем (IP проверим в App.js)
      order: ['localStorage'],
      
      // Куда сохранять выбранный язык
      caches: ['localStorage'],
      
      // Ключ в localStorage
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React сам экранирует XSS
    },
  });

export default i18n;